module.exports = __webpack_public_path__ + "media/images/general/icon_delete-07d9a83fe302d86390c64be5232238c1.svg";